import { useSelector } from 'react-redux';

/**
 * Filtered schedule sessions
 * @param {Number} eventId Event ID
 * @returns array
 */
export function useFilteredSchedule(eventId) {
    return useSelector((state) => state.events[eventId]?.schedule.filtered);
}
